import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';

import Routes from './views/Routes';

import * as AppData from './data/App.data';

import * as AxiosInterceptor from './interceptors/Axios.interceptor';
import * as AppService from './services/App.service.js';
import * as CategoryService from './services/Category.service';

const App = () => {
    const [isInit, setInit] = useState(false);

    useEffect(_ => {
        async function initData() {
            console.log(process.env.API_URL)
            console.log(process.env.REACT_APP_API_URL)

            AxiosInterceptor.init();

            const info = await AppService.getInfo();
            // console.log(info);

            AppData.init(info);

            setInit(true);

            console.log(CategoryService.getCategoryList())
        }
        initData();
        return (_ => {

        })
    }, []);

    return (
        isInit ?
            <BrowserRouter>
                <Routes />
            </BrowserRouter>
            : null
    );
}
export default App;
